import size from "../sizes";
import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Поло из мягкой ткани с идеальным качеством швов. Качество печати и цвета изображения на высочайшем уровне. У воротничка расположены пуговицы. Поло отлично сидит по фигуре.<br/>Материалы: Пике 250 гр/м<sup>2</sup> 100% микрофибра.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`full_print_man_polo`],
      sizeInfo: `full_print_man_polo`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
